import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deletePostRequest, fetchFollowStatusRequest, fetchListUserPostsRequest, fetchStatisticChannelRequest, reactionCommentRequest, reactionPostRequest, reportPostRequest, updateFollowUserRequest, updateListPost } from "../store/actions";

export const useChannel = (dataParam?:any) => {
  const dispatch = useDispatch();
    const {
      loading,
      data,
      lastPage,
      scrollPosition,
      params,
      statistics,
      state_follow,
      loadingStatisticFollow
    } = useSelector((state: any) => state.Community.personal_channel || {});
    const { userInfo } = useSelector((state: any) => state.Auth);
    useEffect(() => {
      console.log(dataParam, 'dataParam',data, userInfo) 
      if (dataParam) {
        const paramsMap = {...params};
        paramsMap.id = dataParam;
        paramsMap.isUserCurrent = userInfo?.id == dataParam;
        paramsMap.auth = userInfo?.id ? true : false;
        dispatch(fetchListUserPostsRequest(paramsMap));
        dispatch(fetchStatisticChannelRequest(paramsMap));
        if(userInfo?.id) {
          dispatch(fetchFollowStatusRequest(paramsMap));
        }
      }
    }, [dataParam, dispatch, userInfo?.id]);
  
  
    const reLoadList = (dataParam: any) => {
      dispatch(fetchListUserPostsRequest(dataParam));
    }
  
    const loadMore = useCallback(() => {
      if (loading) {
        return
      }
      params.page = params?.page + 1
      dispatch(fetchListUserPostsRequest(params));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params?.page, loading])

    const updateStatusFollow = () => {
      dispatch(updateFollowUserRequest(dataParam));
    }
    
  
    return { 
      loading, 
      dataList: data, 
      reLoadList, 
      loadMore, 
      lastPage, 
      scrollPosition, 
      params, 
      statistics,
      updateStatusFollow,
      state_follow,
      loadingStatisticFollow 
    }
};

export function useUpdateListPost() {
  const dispatch = useDispatch();
  const { data } = useSelector((state: any) => state.Community.personal_channel || {});

  const updateList = (id: number) => {

    function removeItemById(list: any, idRemove: any) {
      let listAfterRemove = list;
      listAfterRemove = listAfterRemove.filter((item: any) => item?.id !== idRemove);
      return listAfterRemove;
    }
    const updatedList = removeItemById(data, id);
    dispatch(updateListPost({ listUpdate: updatedList }));
  }

  return { updateList }
}

export function useReportPost() {
  const dispatch = useDispatch();

  const handleReportPost = (data: any) => {
    dispatch(reportPostRequest({id:data}));
  }

  return { handleReportPost };
}

export function useDeletePost() {
  const dispatch = useDispatch();
  const {
    loadingDeletePost,
  } = useSelector((state: any) => state.Community.personal_channel || {});

  const handleDeletePost = (data: any) => {
    dispatch(deletePostRequest({id:data}));
  }

  return { handleDeletePost, loadingDeletePost};
}

export function useReactionPost() {
  console.log('useReactionPost');
  
  const dispatch = useDispatch();

  const handleReactionPost = (data: any) => {
    dispatch(reactionPostRequest(data));
  }

  return { handleReactionPost };
}

export function useReactionComment() {
  const dispatch = useDispatch();

  const handleReactionComment = (data: any) => {
    dispatch(reactionCommentRequest(data));
  }

  return { handleReactionComment };
}